import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog'
import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import { MatButton } from '@angular/material/button'
import { MatDialogContent } from '@angular/material/dialog'
import { TranslationService } from '../../../services/translation.service'

export interface ConfirmDialogData {
  header: string
  message: string
  onCancel?: () => void
  cancelText?: string
  confirmText?: string
}

@Component({
  selector: 'app-confirm-dialog',
  imports: [MatButton, MatDialogContent],
  templateUrl: './confirm-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './confirm-dialog.component.scss',
})
export class ConfirmDialogComponent {
  dialogRef = inject<DialogRef<boolean>>(DialogRef)
  data = inject<ConfirmDialogData>(DIALOG_DATA)
  translationService = inject(TranslationService)

  onCancelClick(): void {
    this.data.onCancel?.()
    this.dialogRef.close(false)
  }

  onConfirmClick(): void {
    this.dialogRef.close(true)
  }
}
